import axiosClient from "../api/axiosClient";

export const getAllPackages = () =>
  axiosClient.get("/Payments/GetAllPackages");
